import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// Core
import { appConfig } from '../../config/app-config';
import { ErrorMessage } from '../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../core/interfaces/bool-result';
import { DataHubService } from '../../core/datahub/datahub.service';

// own module
import { Mangel } from '../../maengel/model/mangel';
import { IMangelResult, MangelResult } from '../../maengel/model/maengel-result';
import { UiMessageSnackService } from '../../core/components/message-snack/service/message-snack.service';

// sleep
function sleep(time) {
   return new Promise((resolve) => setTimeout(resolve, time));
}
sleep(500).then(() => {
   // Do something after the sleep!
});

@Injectable()
export class MaengelDatahubService extends DataHubService {

   constructor(
      http: HttpClient,
      log: UiMessageSnackService,
   ) {
      super(http, log);
   }

   public loadMaengelListe(
      result: Mangel[],                   // output
      debugMode: boolean = false          // DebugMode
   ): Promise<IBoolResult> {
      if (debugMode) { console.log('[DataHubService]:loadMaengelListe(called)'); }

      // mocking case
      if (appConfig.dev.mockingMode) {
         const filepath = `${appConfig.dev.mockingDataFolder}/maengel.json`;

         return this.readFileMapJsonArrayToClass<Mangel>(
            filepath,
            'maengel',
            result,
            Mangel.jsObjToClass,
            debugMode
         );
      }

      // regular HTTP case
      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // error --> send
         reject(new ErrorMessage('mangel/MANGEL_INTERNAL_ERROR', 'Feature noch nicht implementiert'));
      });
      return prom;
   }

   public saveMaengelDetail(
      mangel: any,                     // any to store
      debugMode: boolean = false       // DebugMode
   ): Promise<IBoolResult> {
      if (debugMode) { console.log('[DataHubService]:saveMaengelDetail(called)'); }

      // mocking case
      if (appConfig.dev.mockingMode) {
         // todo
         // log form values
         // return new Promise<IBoolResult>(resolve => {resolve(BoolResult.createBoolResult_true()); });
         const filepath = `${appConfig.dev.mockingDataFolder}/maengel_detail.json`;
         return this.writeFileJsonSchema(
            filepath,
            mangel,
            debugMode
         );
      }

      // regular HTTP case
      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // regular HTTP case
         reject(new ErrorMessage('mangel/MANGEL_INTERNAL_ERROR', 'Feature noch nicht implementiert'));
      });
      return prom;
   }

   public loadMaengelDetailJss(
      debugMode: boolean = false          // DebugMode
   ): Promise<any> {
      if (debugMode) { console.log('[DataHubService]:loadMaengelDetailJss(called)'); }

      // mocking case
      if (appConfig.dev.mockingMode) {
         const filepath = `${appConfig.dev.mockingDataFolder}/maengel_detail.json`;

         return this.readFileJsonSchema(
            filepath,
            debugMode
         );
      }

      // regular HTTP case
      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // error --> send
         reject(new ErrorMessage('mangel/MANGEL_INTERNAL_ERROR', 'Feature noch nicht implementiert'));
      });
      return prom;
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/service/maengel-datahub.service.ts